import { Divider } from "@material-ui/core";
import { Box, Container, Grid, Typography } from "@mui/material";
import axios from "axios";
import {
  FormCard,
  FormLabel,
  ModalError,
  ModalSuccess,
  ModalWarning,
  Page,
  PrimaryButton,
  SecondaryButton,
  SectionLabel,
  SkeletonComponent,
  StatusChip,
} from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import { optionsNewsType } from "./Components/Contants";

const DetailNewsAds = () => {
  const classes = globalStyles();
  const { id } = useParams();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const pageTitle = "News & Ads Detail";

  const [loadingPage, setLoadingPage] = useState(true);
  const [pageDetail, setPageDetail] = useState({});
  const inSubmission = pageDetail?.status === "dalam pengajuan";

  const handleApproval = status => {
    const approve = status === "approve";
    const title = `${approve ? "Approve" : "Reject"} Article`;
    const message = `Are you sure want to ${status} this article ?`;
    ModalWarning(message, title).then(
      res => res?.isConfirmed && postApproval(status)
    );
  };

  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/article/${id}`, {
        headers,
      });
      const { data } = res?.data;
      setPageDetail(data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const postApproval = async status => {
    try {
      await axios.put(
        `${hardBaseUrl}/article/${status}/${id}`,
        {},
        { headers }
      );
      ModalSuccess(`Successfully ${status} article`).then(() =>
        history.goBack()
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };

  useEffect(() => {
    getDetail();
  }, []);
  useEffect(() => {
    if (pageDetail?.content) {
      document.getElementById("contentAsHTML").innerHTML = pageDetail?.content;
    }
  }, [pageDetail]);

  return (
    <Page className={classes.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes?.divider} />
          <FormCard>
            <Grid container justifyContent="space-between">
              <Grid item>
                <Typography mb={1}>Status</Typography>
                <StatusChip
                  label={inSubmission ? "In Submission" : "Approved"}
                  type={!inSubmission && "success"}
                />
              </Grid>
              {inSubmission && (
                <Grid item>
                  <Grid container columnGap={1}>
                    <Grid item>
                      <SecondaryButton
                        label="Reject"
                        onClick={() => handleApproval("reject")}
                      />
                    </Grid>
                    <Grid item>
                      <PrimaryButton
                        label="Approve"
                        onClick={() => handleApproval("approve")}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </FormCard>
          <SectionLabel title="Cover" />
          <FormCard>
            {pageDetail?.banner_image && (
              <img
                alt="banner"
                src={pageDetail?.banner_image}
                className={classes?.bannerImage}
              />
            )}
          </FormCard>
          <Divider className={classes?.divider} />
          <SectionLabel title="Content" />
          <FormCard>
            <Grid container direction="column" rowGap={1}>
              <Grid item>
                <FormLabel label="Title :" />
                <Box p={2} border="1px solid #ebebeb" borderRadius="5px">
                  <Typography>{pageDetail?.title}</Typography>
                </Box>
              </Grid>
              <Grid item>
                <FormLabel label="Type :" />
                <StatusChip
                  label={
                    optionsNewsType.find(item => item.key === pageDetail?.type)
                      ?.label || "News & Ads"
                  }
                  type="active"
                />
              </Grid>
              <Grid item>
                <FormLabel label="Content :" />
                <Box p={2} border="1px solid #ebebeb" borderRadius="5px">
                  <Typography fontSize={16} color="#687083">
                    <Box id="contentAsHTML" />
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </FormCard>
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "News & Ads",
    link: "/admin/berita-publisher",
  },
  {
    label: pageTitle,
    active: true,
  },
];

export default DetailNewsAds;
